// extracted by mini-css-extract-plugin
module.exports = {"backcolor":"Footer_backcolor__3Nbng"};